<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import BannerApi from "@/services/banner-api";
import Vue from 'vue'
// import Promotion from "@/components/promotion"; 

//import DynamicMarquee from 'vue-dynamic-marquee';

// import ItemCard from "@/components/itemCard";
// import CategoryCard from "@/components/CategoryCard";
import highlights from "@/components/highlights-sop";
import highlightsCard from "@/components/highlights-card";



import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// import carousel from 'vue-owl-carousel'
//import simplebar from "simplebar-vue";

import ReportingApi from "@/services/reporting-api";
import UsersApi from "@/services/users-api";

export default {
  page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout/*, simplebar, carousel, ItemCard, CategoryCard*/, highlights, highlightsCard/*, Promotion*/
  },
  
  computed: {

    customerPortalName(){
      return process.env.VUE_APP_CUSTOMER_PORTAL_NAME
    },
    vueAppCustomerInfo() {
      const vueAppCustomerInfo = {
        address: process.env.VUE_APP_CUSTOMER_ADDRESS,
        email: process.env.VUE_APP_CUSTOMER_EMAIL,
        phone: process.env.VUE_APP_CUSTOMER_PHONE,
      };

      return vueAppCustomerInfo;
    },

    windowWidth() {
      return window.innerWidth;
    },
    role() {
      return this.$cookies.get('userr');
    }

  },

  data() {
    return {
      bannerList: [],
      isBannerTableBusy: false,

      nowAvailableItems: [],
      newSuppliers: [],
      newItems: [],

      topItems:[],
      isGetTopItemsStarting: false,

      newAccountCompanyName: null,
      newAccountCompanyPhone: null,

      aboutSection:[
        {
          id:1,
          title: "Prix et Disponibilités",
            description: "Disponibilités et prix instantanés et en temps réel pour tous vos besoins pharmaceutiques.",
          icon: "drugs-pharmacy.svg"
        },
        {
          id:2,
          title: "Commandes en ligne",
            description: "Commandez rapidement et en toute sécurité grâce à notre plateforme intuitive et fiable.",
          icon: "document-medicine.svg"
        },
        {
          id:3,
          title: "Offres et Promotions",
            description: "Suivez nos promotions, actualités et restez informé des dernières nouveautés et offres exclusives.",
          icon: "bell-ringing.svg"
        }
      ],

      agencyList:[
        {
          "name": "SO.PRO.PHA Sfax",
          "address": "AVENUE MAGIDA BOULILA SFAX EL JADIDA",
          "phone1": "(+216) 74 401 500 ",
          "phone2": "(+216) 74 401 510"
        },
        {
          "name": "SO.PRO.PHA Sousse",
          "address": "ROUTE DE MONASTIR KM 1,5 SIDI ABDELHAMID",
          "phone1": "(+216) 73 322 732",
          "phone2": "(+216) 73 322 111"
        },
        {
          "name": "SO.PRO.PHA Medenine",
          "address": "ROUTE DE GABES KM 4",
          "phone1": "(+216) 75 601 825",
          "phone2": "(+216) 75 601 813"
        },
        {
          "name": "SO.PRO.PHA Sidi Bouzid",
          "address": "AVENUE HABIB BOURGUIBA Z.I. SIDI BOUZID",
          "phone1": "(+216) 39 144 594",
          "phone2": "(+216) 76 622 293"
        },

      ]




    };
  },

  mounted() {

    this.findBanner(this.windowWidth);

    this.getTopTenItems();

   
    
  },

  methods: {

    scrollToSection(sectionRef) {
    const section = this.$refs[sectionRef];
    if (section) {
      const offset = -200;
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY + offset;

      window.scrollTo({
        top: sectionPosition,
        behavior: "smooth"
      });
    }
  },

    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

    

    getTopTenItems(){
            this.isGetTopItemsStarting=true
            ReportingApi.getTopTenItemsForHome().then(
                (result) => {
                    this.topItems=result.list;
                }
            ).finally(()=>{
                this.isGetTopItemsStarting=false
            })
      },

      addAccountRequest() {
        UsersApi.addAccountRequest(this.newAccountCompanyName, this.newAccountCompanyPhone)
        .then(
              (result) => {
                  if (result) {
                    Vue.prototype.$snotify.success('Votre demandée est ajoutée avec succès')
                    this.newAccountCompanyName = null;
                    this.newAccountCompanyPhone = null;
                  }
              }
            ).finally(()=>{
            })
      },


      goTopPage() {
        window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
      }

    


  }
};
</script>

<template>
  <Layout>
     
        <!-- Main Banners -->
        <div class="row pt-xl-0 " >
      <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
      <div class="col-12" >
        <div class="p-0" >
            <b-carousel
              style="box-shadow:0 2px 6px 0 rgb(0 0 0 / 8%);"
                img-width="1920"
                img-height="400" 
                :interval="6000"
                

                :controls="false"
                :indicators="false"
                :no-hover-pause="false"
                :no-touch="false"
                :fade="true">

                <b-carousel-slide class="bg-light"  
                          style="width:1920px; height:565px;" 
                          img-blank img-alt="Blank Image " 
                          img-width="1900"
                img-height="400" 
                          v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <!-- <p class="text-secondary">
                    caption="Restez à l'écoute!" 
                    Les publicitées seront disponibles prochainement
                  </p> -->

                </b-carousel-slide> 

                <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
                  <template #img>
                    <div class="banner-overlay"></div>
                    <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%" height="100%" style="min-height:420px">
                  </template>
                

                  <div>

                  

                  </div>

                </b-carousel-slide>
                
                <div  class="carousel-caption text-left ">
                   
                    <h1 class=" font-weight-bold banner-title-white text-uppercase text-primary text-center " style="font-size:3.3rem !important; font-weight:900 !important;">SOPROPHA</h1>
                    <h2 class="d-none d-md-block text-dark mt-4 banner-title-white text-center" style="color: #000 !important;font-weight:900 !important; font-size:2.5rem !important;"> Leader de la répartition pharmaceutique</h2>

                  <h2 class="text-dark font-weight-bold font-size-24 mt-3 mb-5 banner-title-white text-center"  style="color: #000 !important;">
                   Pour vous servir à Sfax, Sousse, Medenine et Sidi Bouzid
                  </h2>



                  <div class="mt-4 text-center" >
                    <a href="/catalogue">
                      <b-button variant="primary"  style="padding: 10px 26px; " class="font-weight-bold  font-size-18">
                        <div class="font-weight-normal mb-1 font-size-14">Consulter le catalogue</div>
                        <span class="font-weight-bold text-uppercase ">Passer votre commande</span>
                      </b-button>
                    </a>    
                  </div>




                 




                </div>
                
              
            </b-carousel>



        </div>
      </div>


    </div>






    <div>


    </div>







        <!--div class="pt-xl-0 pb-0" >
          <div class="catalog-background ">

            <div class="home-page-80-width " >
              <div class="col-md-6 text-uppercase text-primary font-weight-bold "  >
                <div class="header-title" >
                  Leader de la répartition pharmaceutique 
                </div>
                <div class="text-dark text-justify mt-3 d-md-inline d-none " style="max-width: 80%; letter-spacing: 0.01em;">
                  <strong>SO PRO PHA</strong> est le leader de la répartition pharmaceutique. Engagé auprès des Pharmaciens pour les accompagner au quotidien, notre groupe joue un rôle crucial dans l’accessibilité des soins et la distribution de médicaments.
                </div>
              </div>
            </div>
          </div>
				</div-->

        
        <div ref="aboutSection" class="card text-center d-none d-md-block">
          <div class="card-body  p-md-5 p-2">
            <div class="row">
              <div v-for="element in aboutSection" :key="element.id" class="col-md-4 col-12 fancy-animation">
                <div class="row p-2 align-items-center h-100">
                  <div class="col-md-3 col-12 font-size-14 d-flex align-items-center justify-content-center " >
                    <img :src="require(`@/assets/images/${element.icon}`)" height="55px" class="mr-0 ml-0" />
                  </div>
                  <div class="col-md-9 col-12 text-md-left text-center pl-md-4 pl-0">
                    <!-- <div class="text-dark font-weight-bold text-uppercase font-size-24">{{ element.id }}</div> -->

                    <div class="text-primary font-weight-bold text-uppercase" style="font-size:1.2rem !important;">{{ element.title }}</div>
                    <div class="text-dark text-md-left text-justify font-weight-bold" style="font-size:0.9rem !important;">{{ element.description }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="float-md-right float-center mt-2 mb-2 mr-md-4 m-0 fancy-animation mt-5">
              <a href="/catalogue" >
                <b-button variant="outline-primary" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0  custom-button" style="letter-spacing: 0.03em;">
                <span class="text-uppercase font-size-14 font-weight-bold mr-1">Passez vos commandes</span>     <img src="@/assets/images/arrow-right-w.svg" height="21px" class="ml-md-3 d-md-inline d-none" />
                </b-button>
              </a>
            </div> -->
          </div>
        </div>


        <!-- :style="{ background: `linear-gradient(to right, #dddddde6 25%,rgba(0, 52, 58, 0.48) 90%), url(${require('@/assets/images/a-propos.jpg')})`, backgroundSize: 'cover', backgroundPosition: 'center' }" -->
        <div class="card " >
        
          <div class="home-page-80-width " >  

            <div class="row home-page-80-width mt-3">

              <div class="col-lg-6 col-12 d-none d-lg-flex align-items-center justify-content-center p-5">
                <img  
                  class="" 
                  src="@/assets/images/sop/a-propos.jpg" 
                  alt="Au service des pharmaciens" 
                  width="100%"  
                  style="border-radius: 8px; "
                />

              </div>

              <div class="col-lg-6 col-12 text-primary p-md-5 p-3">

                <div class="text-primary font-weight-bold text-left text-center text-md-left" >
                  
                  <div style="font-size:1.7rem;">A propos de SOPROPHA</div>
                  <span class="text-dark font-size-18">Société de Produits Pharmaceutiques</span>
                </div>


                
                <p class="text-dark mt-3 text-justify font-size-16 pt-3" style="line-height: 2;">
                 SOPROPHA est une entreprise tunisienne spécialisée dans la distribution de produits pharmaceutiques. Basée à Sfax avec des agences à Sousse, Medenine et Sidi Bouzid, elle joue un rôle clé dans l'approvisionnement des pharmacies et établissements de santé de la région. Grâce à un réseau logistique performant et une expertise reconnue, SOPROPHA s'engage à garantir la disponibilité de médicaments sûrs et de qualité. L'entreprise incarne les valeurs de rigueur, de réactivité et de service au sein du secteur pharmaceutique en Tunisie.
                </p>
                

              </div>


              

            </div>

        </div>
    </div>


    <div ref="activitySection"></div>

    <highlightsCard :propDisplayTitle="true"  />


      <div ref="eventsSection"></div>

      <highlights  :propDisplayTitle="true"  class="bg-white" />

     

      <div ref="addressesSection" class="bg-white home-page-80-width align-items-center ">
        <!-- <div class="section-header mt-4 mb-4">
          <div class="col-12 text-primary text-uppercase font-size-18" style="letter-spacing: 0.05em; line-height: 1.8; font-weight: 600">
            Nos adresses
          </div>
        </div> -->
        <div class="row mt-5 mb-5">
          
          <div class="col-md-6 col-12">
            <!-- Agency List -->
            <div class="mt-1" v-for="(agency, index) in agencyList" :key="index">
              <div class="mb-1 agency-card p-3">
                <div class="text-primary font-size-18 mb-2 d-flex align-items-center font-weight-bold">
                  <!-- <img src="@/assets/images/marker-pin-pr.svg" height="25" class="mr-2" /> -->
                  <span>{{ agency.name }}</span>
                </div>
                <div class="text-dark font-size-14 mb-1">{{ agency.address }}</div>
                <div class="text-dark font-size-14 mb-1">
                  <i class="fas fa-phone-alt mr-2"></i>{{ agency.phone1 }}
                </div>
                <div v-if="agency.phone2" class="text-dark font-size-14">
                  <i class="fas fa-phone-alt mr-2"></i>{{ agency.phone2 }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-12 d-none d-md-block ">
            <div class="map-container p-3">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3278.730465608048!2d10.750951700000002!3d34.7371878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13002cd4c141ccdf%3A0x34a8301c96fd97fb!2sSoci%C3%A9t%C3%A9%20des%20Produits%20Pharmaceutiques!5e0!3m2!1sfr!2stn!4v1740157224594!5m2!1sfr!2stn" width="600" height="500" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>            </div>
          </div>
        </div>
      </div>
            
       
      <!-- :style="{ background: `linear-gradient(to right, #dddddde6 25%,rgba(0, 52, 58, 0.48) 90%), url(${require('@/assets/images/a-propos.jpg')})`, backgroundSize: 'cover', backgroundPosition: 'center' }" -->
      <div class="bg-light  " >
          <div class="row " style="margin: auto;max-width: 80%;letter-spacing: 0.01em; padding-bottom: 50px; padding-top: 50px;">
            <div class="col-12"> 

                <div class="row pb-1">

                  <div class="col-xl-5 col-md-6 col-sm-12 col-xs-12 text-md-left pr-2 text-center mb-3" >
                    <img src="@/assets/images/sop/logo.png" alt height="100px" width="auto" />
            
                      <!-- <div  class="text-dark text-justify font-size-14 pl-md-2 pl-0" >
                        <strong>SO PRO PHA</strong> est le leader de la répartition pharmaceutique. Engagé auprès des Pharmaciens pour les accompagner au quotidien, notre groupe joue un rôle crucial dans l’accessibilité des soins et la distribution de médicaments.
                      </div> -->

                  </div>


                  <div class="col-xl-7 col-md-6 col-sm-12 col-xs-12 pl-2">

                    <div class="row">

                      <div class="col-xl-4 col-md-6 col-sm-12 col-xs-12 p-2 text-left pt-md-0 pt-4" >
                          <h5 class="text-primary font-weight-bold " >CONTACTEZ-NOUS</h5>


                            <ul style="list-style: none;margin: 0;padding: 0; " class="mt-4">
                                <li class="text-dark font-weight-normal font-size-14 mt-2">
                                  <!-- <i class=" fas fa-map-marker-alt mr-2  text-primary"/> -->
                                  <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.address}}</span>
                                </li>

                                <li class="font-weight-normal font-size-14 mt-2">
                                  <!-- <i class="fas fa-envelope mr-2  text-primary"/> -->
                                  <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.email}}</span>
                                </li>          
                                
                                <li class=" font-weight-normal font-size-14 mt-2">
                                  <!-- <i class=" fas fa-clock mr-2  text-primary"/> -->
                                  <span class="text-dark font-weight-normal font-italic">Du lundi au samedi de 08h à 17h</span>
                                </li>

                                <li class=" font-weight-normal font-size-14 mt-2">
                                  <!-- <i class=" fas fa-phone-alt mr-2  text-primary"/> -->
                                  <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.phone}}</span>
                                </li>    
                            </ul>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 col-xs-12 p-2 text-left pt-md-0 pt-4">
                            <h5 class="text-primary font-weight-bold text-uppercase">Menu</h5>
                            <ul style="list-style: none; margin: 0; padding: 0;" class="mt-4">
                              <li class="font-size-14 mt-2">
                                <a class="text-dark" href="#" @click.prevent="scrollToSection('aboutSection')">
                                  <!-- <i class="fas fa-info-circle mr-2 text-primary"></i> -->
                                  A propos
                                </a>
                              </li>
                              <li class="font-size-14 mt-2">
                                <a class="text-dark" href="#" @click.prevent="scrollToSection('eventsSection')">
                                  <!-- <i class="fas fa-calendar-alt mr-2 text-primary"></i> -->
                                  Évènements et actualités
                                </a>
                              </li>
                              <li class="font-size-14 mt-2">
                                <a class="text-dark" href="#" @click.prevent="scrollToSection('activitySection')">
                                  <!-- <i class="fas fa-tasks mr-2 text-primary"></i> -->
                                  Activité
                                </a>
                              </li>
                              <li class="font-size-14 mt-2">
                                <a class="text-dark" href="#" @click.prevent="scrollToSection('addressesSection')">
                                  <!-- <i class="fas fa-map-marker-alt mr-2 text-primary"></i> -->
                                  Nos adresses
                                </a>
                              </li>
                            </ul>
                          </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 col-xs-12 p-2 text-left pt-md-0 pt-4" >
                          <h5 class="text-primary font-weight-bold text-uppercase" style="">{{customerPortalName}}</h5>
                          <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                              
                                <li class="font-size-14 mt-2">
                                  <!-- <i class="fas fa-user-tie mr-2 text-primary"></i> -->
                                  <a class="text-dark" href="/catalogue">Espace Client</a>
                                </li>
                                
                                <li class="font-size-14 mt-2">

                                  <!-- <i class="fas fa-user-tie mr-2 text-primary"></i> -->
                                  <a class="text-dark" href="/catalogue">Espace Fournisseur</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                  </div>



                </div>
            </div>
          </div>
      </div>


  </Layout>
</template>


<style lang="scss" scoped>
/* Define the animation */
@keyframes fadeInSlideUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.fancy-animation {
  opacity: 0;
  animation: fadeInSlideUp 0.8s ease-out forwards;
}

.fancy-animation:nth-child(1) {
  animation-delay: 0.2s;
}
.fancy-animation:nth-child(2) {
  animation-delay: 0.4s;
}
.fancy-animation:nth-child(3) {
  animation-delay: 0.6s;
}


.custom-button {
  position: relative;
  overflow: hidden;
  background-color: transparent;
  border: 2px solid $primary;
  color: $primary;
  border-radius: 20px;
  transition: color 0.3s ease;
  z-index: 1;
  
}

.custom-button::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 0; 
  height: 100%;
  width: 17%;
  background-color: $primary;
  
  transition: width 0.3s ease; 
  z-index: -1; 
}

@media (max-width: 768px) {
  .custom-button::before {
    width: 0%;
  }
}
.custom-button:hover {
  color: white; 
}

.custom-button:hover::before {
  width: 100%; 
}
</style>

<style scoped>

/*.translation-section {
  width: 70%;
 transform: translateY(-80px);
  box-shadow: 0px 30px 50px 0px rgb(233, 233, 243);
  border-radius: 5px;
  margin: 0 auto;
  margin-top:100px;
  z-index:2;
}*/


.trending-content a span.img-marq {
    display: inline-block;
    line-height: 1;
    margin-right: 15px;
    position: relative;
}

.slick-arrow:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.newitems .simplebar-scrollbar::before {
  background-color: #5cb45b;
}

.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}


carousel-item .active .img-fluid {
  border-radius:500px !important;
}

@media all and (max-width: 1199px) {
    .mobile-padding {
        padding-left: 20px !important;
        padding-right: 20px !important;
    } 
  }



.carousel-caption {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  z-index: 2;
}

@media (max-width: 768px) {
  .carousel-caption {
    top: 40%;
    font-size: 0.9rem;
    padding: 0 10px;
  }
}

@media (min-width: 769px) and (max-width: 1190px) {
  .carousel-caption {
    top: 40%;
    font-size: 0.9rem;
    padding: 0 10px;
  }
}
.banner-image {
  position: relative;
  z-index: 0;
}



/*.catalog-background {
  padding-top: 180px;
    padding-bottom: 180px;
    background: linear-gradient(42deg, rgba(246,246,246,1) 35%, rgba(0,212,255,0) 100%), url('~@/assets/images/sop/background/back.jpg');
    background-position: center;
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}*/

.banner-overlay {

 position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgb(192 199 195 / 66%));
  /*linear-gradient(to right, rgb(255 255 255 / 60%) 10%, rgb(0 100 0 / 46%) 90%);*/
  z-index: 1;
  pointer-events: none;

}



.map-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px; /* Rounded corners */
  overflow: hidden; /* Ensures the content respects the border radius */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Adds a subtle shadow */
  background-color: #f9f9f9; /* Light background for better contrast */
}

.map-container iframe {
  border: none; /* Removes default iframe border */
  width: 100%;
  height: 100%;
}

.map-container img {
  max-height: 400px;
  width: 100%;
  object-fit: cover;
  border-radius: 15px; /* Matches the container's border radius */
}


.font-size-18 {
  font-size: 18px;
}

.font-size-14 {
  font-size: 14px;
}

.text-primary {
  color: #007bff;
}

.text-dark {
  color: #6c757d;
}

.header-title {
  font-size: 50px;
  line-height: 66px;

  @media (max-width: 768px) {
    font-size: 35px;
    line-height: 40px;
    margin-left: 10px;
  }
}

.banner-title-white {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #fff; font-weight: 700;
}

.banner-title {
  font-size:3rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); 
  font-weight: 700;
}

</style>
